import { honorMessage } from '@/api/honor'

const state = {

}

const mutations = {

}

const actions = {
  honorMessage ({ commit }) {
    // console.log(data)
    return new Promise((resolve, reject) => {
      honorMessage().then((res) => {
        // console.log(resolve(res))
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
